export default __webpack_public_path__ + "static/media/pencil-icon-blue.b6a3a382.svg";